import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {Title} from '@angular/platform-browser';
import {ChangeRequestService, DomainService} from 'common-domain';
import {
  AuthService,
  ChangeRequestVO,
  RequestMetadata,
  requiredFieldValidator,
  whitelistCharacterValidator
} from 'common-domain';

@Component({
    selector: 'app-ac-tc-confirmation',
    templateUrl: './ac-tc-confirmation.component.html',
    styleUrls: ['./ac-tc-confirmation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AcTcConfirmationComponent implements OnInit {

  changeRequestAcceptRejectForm: FormGroup;
  email: string;
  requestedDate: any;
  token: string;
  changeRequestVO: ChangeRequestVO;
  successMessage: string;
  errorMessage: string;
  error: any;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private formBuilder: FormBuilder,
              private titleService: Title,
              private domainService: DomainService,
              private changeRequestService: ChangeRequestService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.titleService.setTitle('Authorize Change Request');
    this.getInputData(history.state);
    this.createForm();
  }

  onSubmit(target: HTMLElement) {
    this.successMessage = this.errorMessage = this.error = undefined;
    const formValue = this.changeRequestAcceptRejectForm.value;
    const response = formValue.changeRequestAction === 'APPROVE';
    this.changeRequestService.acTCcontactConfirmationResponse(this.changeRequestVO.id, response, formValue.comment, this.email)
      .subscribe(data => {
        this.successMessage = 'Thank you for your response. If you have any questions about this request, contact IANA Root Zone Management at root-mgmt@iana.org';
        setTimeout(() => target.scrollIntoView({behavior: 'smooth'}));
      }, error => {
        this.error = error;
        this.errorMessage = 'If you have any questions about this request, contact IANA Root Zone Management at root-mgmt@iana.org';
        console.log(error);
        setTimeout(() => target.scrollIntoView({behavior: 'smooth'}));
      });
  }

  getInputData(navigatedData) {
    if (!this.route.snapshot || !this.route.snapshot.paramMap) {
      this.goHome();
    } else {
      this.token = this.route.snapshot.paramMap.get('token');
      const data = JSON.parse(atob(this.route.snapshot.paramMap.get('data').replace(/_/g, '/').replace(/-/g, '+')));
      this.email = data.email;
      this.changeRequestVO = {} as ChangeRequestVO;
      this.changeRequestVO.id = data.changeRequestId;
      this.changeRequestVO.tldName = data.tldName;
      this.changeRequestVO.requestMetadata = {} as RequestMetadata;
      this.changeRequestVO.requestMetadata.submitterEmail = data.requester;
      this.changeRequestVO.requestMetadata.dateOfSubmission = data.requestedDate;
      const nameAndHtml = this.tryParseHtml(data.htmlContentOfChange);
      this.changeRequestVO.changesHtml = {};
      this.changeRequestVO.changesHtml[nameAndHtml.name] = [nameAndHtml.html];
    }

  }

  goHome() {
    this.authService.redirectToHome('Token Invalid/Expired');
  }


  isFormInValid(): boolean {
    const valid = this.changeRequestAcceptRejectForm.valid;
    if (!valid) {
      return true;
    }
    const reason = this.changeRequestAcceptRejectForm.value.comment;
    const action = this.changeRequestAcceptRejectForm.value.changeRequestAction;

    if (action === 'APPROVE') {
      return false;
    } else if (action === 'REJECT') {
      return !reason;
    } else {
      return true;
    }
  }

  get comment(): FormControl { return this.changeRequestAcceptRejectForm.get('comment') as FormControl; }

  private createForm() {
    this.changeRequestAcceptRejectForm = this.formBuilder.group({
      changeRequestAction: new FormControl('', [requiredFieldValidator]),
      comment: new FormControl('', whitelistCharacterValidator)
    });
  }

  /**
   * Try to parse the first html element to have a better naming in the summary of change box
   * @param htmlContentOfChange the html serialized content coming from the url
   * @returns a meaningful name representing the first html element or summary if not available with corresponding html
   */
  tryParseHtml(htmlContentOfChange: string): any {
    try {
      const template = document.createElement('template') as any;
      template.innerHTML = htmlContentOfChange.trim();
      return {
        name: this.removeIllegalJsonCharacter(template.content.firstChild.textContent),
        html: htmlContentOfChange.replace(template.content.firstChild.outerHTML, '').replace('<br />', '')
      };
    } catch (err) {
      return {
        name: 'Summary',
        html: htmlContentOfChange
      };
    }
  }

  private removeIllegalJsonCharacter(matche: string) {
    return matche.replace(/[!@#$^&%*()+=[\]/{}|:<>?,.\\-]/g, '');
  }
}
